// ********* Import CSS ******************** //

import "./flyer-popup.css";


// **************** Modal ******************** //

class FlyerPopup extends HTMLElement {
  connectedCallback() {

    this.innerHTML = `

      <div id="flyer-popup" class="modal">

        <span id="close-modal" class="close">&times;</span>

        <img class="flyer-modal-content" id="img01" width="100px">

      </div>
    `
  }
}

customElements.define('flyer-popup', FlyerPopup);


// ********************** Flyer Popup Modal *********************** //

var flyerPopup = document.getElementById('flyer-popup');

const flyerButton0 = document.getElementById("flyerButton0");
const flyerButton0a = document.getElementById("flyerButton0a");

const flyerButton1 = document.getElementById("flyerButton1");
const flyerButton2 = document.getElementById("flyerButton2");
const flyerButton3 = document.getElementById("flyerButton3");
const flyerButton4 = document.getElementById("flyerButton4");
const flyerButton5 = document.getElementById("flyerButton5");
const flyerButton6 = document.getElementById("flyerButton6");

var flyerImg0 = document.getElementById("flyerImg0");
var flyerImg0a = document.getElementById("flyerImg0a");

var flyerImg1 = document.getElementById("flyerImg1");
var flyerImg2 = document.getElementById("flyerImg2");
var flyerImg3 = document.getElementById("flyerImg3");
var flyerImg4 = document.getElementById("flyerImg4");
var flyerImg5 = document.getElementById("flyerImg5");
var flyerImg6 = document.getElementById("flyerImg6");

var modalImg = document.getElementById("img01");


// ************** BEGIN: Close Flyer Popup Modal ******************//

var flyerModalClose = document.getElementById('close-modal');

flyerModalClose.addEventListener('click', event => {
  flyerPopup.style.display = "none";
});

// *************** END: Close Flyer Popup Modal ******************//


// ************** BEGIN: Open Flyer Popup Modal ******************//

if (flyerButton0) {
  flyerButton0.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg0.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton0a) {
  flyerButton0a.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg0a.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton1) {
  flyerButton1.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg1.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton2) {
  flyerButton2.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg2.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton3) {
  flyerButton3.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg3.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton4) {
  flyerButton4.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg4.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton5) {
  flyerButton5.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg5.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}

if (flyerButton6) {
  flyerButton6.addEventListener('click', (event) => {

    event.preventDefault();

    // console.log("Flyer Image Clicked");

    var imgSrc = flyerImg6.src;

    // console.log("Img Src: ", imgSrc);

    flyerPopup.style.display = "block";

    modalImg.src = imgSrc;
  });
}









